import { CollapsibleTrigger } from 'components/Collapsible';
import { cn } from 'utils/shadcn';

import { TriggerLabelSection } from './TriggerLabelSection';

type CollapsibleTriggerSectionProps = {
  label: string;
  open: boolean;
  className?: string;
};

export function CollapsibleTriggerSection({
  label,
  open,
  className,
}: CollapsibleTriggerSectionProps) {
  return (
    <CollapsibleTrigger
      className={cn(
        'w-full cursor-pointer border-t border-neutral-200 py-2 hover:bg-neutral-100/75 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand',
        className
      )}
      onClick={(event) => {
        // Keep expand/collapse independent of whole-card selection.
        event.stopPropagation();
      }}
    >
      <TriggerLabelSection label={label} open={open} />
    </CollapsibleTrigger>
  );
}
